import script from "./Dialong.vue?vue&type=script&setup=true&lang=js"
export * from "./Dialong.vue?vue&type=script&setup=true&lang=js"

import "./Dialong.vue?vue&type=style&index=0&id=c3879518&lang=less&scoped=true"

import exportComponent from "F:\\project\\trade_lab_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3879518"]])

export default __exports__